import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PromotionsState } from './types';
import { PromoTypes } from '../../components/Layout/Promotions/types';
import { storageClaimedPromo } from '../../utils/storage';

const initialState: PromotionsState = {
  loadPlatformPromotions: storageClaimedPromo.get() ? false : true,
  activePromoType: null,
};

export const promotionsSlice = createSlice({
  name: 'promotions',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setLoadPlatformPromotions: (state: PromotionsState, action: PayloadAction<boolean>) => {
      return {
        ...state,
        loadPlatformPromotions: action.payload,
      };
    },
    setActivePromoType: (state: PromotionsState, action: PayloadAction<PromoTypes>) => {
      return {
        ...state,
        activePromoType: action.payload,
      };
    },
  },
});

export const { setLoadPlatformPromotions, setActivePromoType } = promotionsSlice.actions;

export default promotionsSlice.reducer;
